module.exports = __webpack_public_path__ + "static/img/wx_icon.cfdbfd26.png";